import React from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from 'react-to-webcomponent';
import PropTypes from 'prop-types';
import styles from './styles.css';
import App from "./App";

const Index = (props) => {
	
	const lang  = props.Lang;
	const token = props.Token;
	const color = props.Color;
	const uuid  = "36d61457-a5da-483d-81d5-bb0bbbb933c1";
	const source = props.Source;
	const destination = props.Destination;

	return (
		
		<>
			{
				<App lang={lang} token={token} uuid={uuid} color={color} source={source} destination={destination}  ></App>
			}
		</>
	
	);
};

Index.propTypes = {
	lang: PropTypes.string,
	token: PropTypes.string,
	uuid: PropTypes.string,
	color: PropTypes.string,
	source: PropTypes.string,
	destination: PropTypes.string,
}

customElements.define(
	"tn-anreise",
	reactToWebComponent(Index, React, ReactDOM, {
		props: ["Lang","Token","Uuid","Color","Source","Destination" ],
	}),
)